<template>
    <div>
        <div class="form-group" v-bind:class="{ 'has-error' : validationErrors.has('cta_type') }">
            <label class="control-label">{{ trans('Type') }}</label>
            <select name="cta_type" class="form-control" v-model="selectedType">
                <option value="">{{ trans('Select a destination type') }}</option>
                <option v-for="item in types" v-bind:key="item.id" v-bind:value="item.id">{{ item.name }}</option>
            </select>
        </div>

        <div v-if="selectedType === 'external_url'" class="form-group" v-bind:class="{ 'has-error' : validationErrors.has('cta_link') }">
            <label>
                {{ trans('External URL') }}
                <input class="input__field" type="text" v-model="selectedLink" name="cta_link">
            </label>
        </div>
        <div v-else-if="selectedType === 'checkout_page'" class="form-group" v-bind:class="{ 'has-error' : validationErrors.has('cta_link') }">
            <label class="control-label">{{ trans('Membership') }}</label>
            <select name="cta_link" class="form-control" v-model="selectedLink">
                <option value="">{{ trans('Select a membership') }}</option>
                <option v-for="item in memberships" v-bind:key="item.encoded_id" v-bind:value="item.encoded_id">{{ item.name }}</option>
            </select>
        </div>
        <div v-else-if="selectedType === 'sales_popup'" class="form-group" v-bind:class="{ 'has-error' : validationErrors.has('cta_link') }">
            <label class="control-label">{{ trans('Sales Popup') }}</label>
            <select name="cta_link" class="form-control" v-model="selectedLink">
                <option value="">{{ trans('Select a sales popup') }}</option>
                <option v-for="popup in productsWithSalesPopups" v-bind:key="popup.id" v-bind:value="popup.id">{{ popup.name }}</option>
            </select>
        </div>
        <div v-if="validationErrors.has('cta_type')" class="form-help">{{ validationErrors.first('cta_type') }}</div>
        <div v-else-if="validationErrors.has('cta_link')" class="form-help">{{ validationErrors.first('cta_link') }}</div>
    </div>
</template>
<script>
import Errors from '../../errors.js';

export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        link: {
            type: String,
            required: true,
        },
        errors: {
            type: [Array, Object]
        },
        memberships: {
            type: Array,
            required: true,
        },
        products: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedType: this.type,
            selectedLink: this.link,
            types: [
                {
                    id: 'external_url',
                    name: this.trans('External URL'),
                },
                {
                    id: 'checkout_page',
                    name: this.trans('Checkout Page'),
                },
                {
                    id: 'sales_popup',
                    name: this.trans('Sales Popup'),
                },
            ],
            productsWithSalesPopups: this.products.filter((product) => product.sales_popup).map((product) => ({
                'id': product.encoded_id,
                'name': product.title + ' - ' + product.sales_popup.name,
            })), // We use products with popups instead of memberships with popups because when rendering a popup we need to load a product that uses it
            validationErrors: new Errors(this.errors || {}),
        }
    },
    watch: {
        selectedType(newType) {
            this.selectedLink = '';
            this.validationErrors.clear();
        },
    },
}
</script>